import React, { useState } from 'react';
import { useStatic } from '../context/StaticContext';
import { LANGUAGE_OPTIONS, getLanguageFlag } from '../helper/languageHelper';
import { IoChevronDown } from 'react-icons/io5';

const LanguageSelector = () => {
  const { selectedLanguage, setSelectedLanguage } = useStatic();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (languageCode) => {
    setSelectedLanguage(languageCode);
    setIsOpen(false);
  };

  const selectedLang = LANGUAGE_OPTIONS.find(lang => lang.code === selectedLanguage);

  return (
    <div className="language-selector">
      <button
        className="language-selector-button"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span className="language-flag">
          {selectedLang ? selectedLang.flag : '🌐'}
        </span>
        <span className="language-name">
          {selectedLang ? selectedLang.name.split(' (')[0] : 'Language'}
        </span>
        <IoChevronDown 
          className={`language-chevron ${isOpen ? 'open' : ''}`} 
          size={16} 
        />
      </button>

      {isOpen && (
        <div className="language-dropdown">
          {LANGUAGE_OPTIONS.map((language) => (
            <button
              key={language.code}
              className={`language-option ${selectedLanguage === language.code ? 'active' : ''}`}
              onClick={() => handleLanguageChange(language.code)}
              type="button"
            >
              <span className="language-flag">{language.flag}</span>
              <span className="language-name">{language.name}</span>
              {selectedLanguage === language.code && (
                <span className="language-checkmark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}

      {isOpen && (
        <div 
          className="language-backdrop" 
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default LanguageSelector; 